var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28953",
    "data-name": "Group 28953",
    transform: "translate(-58 -5371.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(58 5371.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36206",
    "data-name": "Path 36206",
    d: "M51.11,1.25H15.39A14.151,14.151,0,0,0,1.25,15.39V51.11A14.151,14.151,0,0,0,15.39,65.25H51.11A14.151,14.151,0,0,0,65.25,51.11V15.39A14.151,14.151,0,0,0,51.11,1.25Zm9.674,49.86a9.692,9.692,0,0,1-9.674,9.674H15.39A9.692,9.692,0,0,1,5.715,51.11V15.39A9.692,9.692,0,0,1,15.39,5.715H51.11a9.692,9.692,0,0,1,9.674,9.674Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#0180e5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1543",
    "data-name": "Ellipse 1543",
    cx: 8.186,
    cy: 8.186,
    r: 8.186,
    transform: "translate(35.721 8.93)",
    fill: "#0180e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36207",
    "data-name": "Path 36207",
    d: "M47.39,43.231a7.927,7.927,0,0,1-.3,2.233H15.39A14.151,14.151,0,0,1,1.25,31.324V14.535a29.1,29.1,0,0,1,4.465-1.786A32.015,32.015,0,0,1,47.3,41q.089,1.116.089,2.233Z",
    transform: "translate(-1.25 18.536)",
    fill: "#0180e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36208",
    "data-name": "Path 36208",
    d: "M37.576,17.018v8.394a14.151,14.151,0,0,1-14.14,14.14h-.982a10.915,10.915,0,0,0,.238-2.233c0-.833-.03-1.637-.089-2.441A34.474,34.474,0,0,0,15.25,15.828a30.66,30.66,0,0,1,9.674-1.578,29.869,29.869,0,0,1,8.186,1.131,25.83,25.83,0,0,1,4.465,1.637Z",
    transform: "translate(26.424 24.448)",
    fill: "#0180e5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapture);
export default __webpack_public_path__ + "static/media/capture.a5892351fd35d1c59398625547f16d2a.svg";
export { ForwardRef as ReactComponent };